import { useMutation } from '@tanstack/react-query';
import { Button, Input, Modal } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useState } from 'react';
import { confirmOvertimeTicket } from 'src/apis/hr_ticket/overtimeTicket.api';
import { ConfirmOvertimeRq } from 'src/types/hr_ticket/overtimeTicket.type';
import { OpenAddNoteType } from './OvertimeTicketDrawer';
import { showNotification } from 'src/utils/notification';
import { ConfirmTypeEn } from 'src/constants/confirmTypeEn.enum';

interface Props {
  open: OpenAddNoteType;
  setOpen: React.Dispatch<React.SetStateAction<OpenAddNoteType>>;
  handleRefresh: (id: number) => void;
}

export default function AddNoteForUnConfirm({ open, setOpen, handleRefresh }: Props) {
  const [form] = useForm();
  const [note, setNote] = useState<string>('');

  const unConfirmOvertimeTicketMutation = useMutation({
    mutationFn: (body: ConfirmOvertimeRq) => confirmOvertimeTicket(body)
  });

  const handleUnConfirmComplete = (id: number, note: string) => {
    unConfirmOvertimeTicketMutation.mutate(
      {
        id,
        confirmNote: note,
        isConfirm: ConfirmTypeEn.Reject
      },
      {
        onSuccess: () => {
          showNotification('Từ chối xác nhận phiếu tăng ca thành công', 'success');
          handleRefresh(open.id as number);
          setOpen((prev) => ({ ...prev, isOpen: false }));
        }
      }
    );
  };

  const handleCancel = () => {
    form.resetFields();
    setOpen({
      ...open,
      isOpen: false
    });
    setNote('');
  };

  const handleSubmit = () => {
    form.validateFields().then(() => {
      if (open.id) {
        handleUnConfirmComplete(open.id, note);
      }
    });
  };

  return (
    <Modal
      title={`Không xác nhận phiếu tăng ca - Raise ticket - ${open.code}`}
      style={{ maxWidth: 800 }}
      maskClosable={false}
      open={open.isOpen}
      onOk={handleSubmit}
      onCancel={handleCancel}
      centered
      footer={[
        <Button key='back' onClick={handleCancel}>
          Hủy
        </Button>,
        <Button key='submit' type='primary' onClick={handleSubmit} loading={unConfirmOvertimeTicketMutation.isLoading}>
          Lưu
        </Button>
      ]}
    >
      <Input.TextArea
        rows={5}
        value={note}
        placeholder={'Nhập ghi chú không xác nhận phiếu tăng ca - Raise ticket'}
        onChange={(e) => setNote(e.target.value)}
      />
    </Modal>
  );
}
